var map = {
	"./docs/action-sheet.md": [
		"1460",
		"chunk-2d0ab113"
	],
	"./docs/article.md": [
		"3b76",
		"chunk-1f06de58"
	],
	"./docs/badge.md": [
		"70bb",
		"chunk-2d0d61cf"
	],
	"./docs/button.md": [
		"039f",
		"chunk-2d0a3986"
	],
	"./docs/changelog.md": [
		"6a82",
		"chunk-2d0da01b"
	],
	"./docs/customize-theme.md": [
		"cf0f",
		"chunk-2d2226cf"
	],
	"./docs/dialog.md": [
		"0cb4",
		"chunk-2d0af27b"
	],
	"./docs/flex.md": [
		"0f9e",
		"chunk-4584e0b6"
	],
	"./docs/footer.md": [
		"b45f",
		"chunk-2d20f759"
	],
	"./docs/form-access.md": [
		"34e9",
		"chunk-2d0b9f8b"
	],
	"./docs/form-checkbox.md": [
		"2b37",
		"chunk-2d0bd1ca"
	],
	"./docs/form-input-status.md": [
		"ffed",
		"chunk-2d238a55"
	],
	"./docs/form-page.md": [
		"32dc",
		"chunk-2d0b9814"
	],
	"./docs/form-radio.md": [
		"9250",
		"chunk-2d0e4c6a"
	],
	"./docs/form-select-primary.md": [
		"497c",
		"chunk-2d0c2147"
	],
	"./docs/form-select.md": [
		"6b7d",
		"chunk-2d0da3ef"
	],
	"./docs/form-switch.md": [
		"5bdd",
		"chunk-2d0d3503"
	],
	"./docs/form-textarea.md": [
		"8870",
		"chunk-2d0deecf"
	],
	"./docs/form-vcode.md": [
		"46cc",
		"chunk-2d0c1b58"
	],
	"./docs/form.md": [
		"49da",
		"chunk-2d0c26b8"
	],
	"./docs/gallery.md": [
		"888a",
		"chunk-2d0def1f"
	],
	"./docs/getting-started.md": [
		"0458",
		"chunk-5407bc6f"
	],
	"./docs/grid.md": [
		"b1a9",
		"chunk-427b0eb0"
	],
	"./docs/half-screen-dialog.md": [
		"63e7",
		"chunk-2d0cf8e5"
	],
	"./docs/icons.md": [
		"4af7",
		"chunk-2d0cbcf4"
	],
	"./docs/introduce.md": [
		"09cf",
		"chunk-7a46fa80"
	],
	"./docs/list.md": [
		"2dd5",
		"chunk-2d0bdf39"
	],
	"./docs/loading.md": [
		"633c",
		"chunk-2d0cf303"
	],
	"./docs/loadmore.md": [
		"7a15",
		"chunk-2d0e13a4"
	],
	"./docs/msg.md": [
		"cd36",
		"chunk-2d221f7a"
	],
	"./docs/navbar.md": [
		"2aaa",
		"chunk-2d0bd3c5"
	],
	"./docs/panel.md": [
		"dc8d",
		"chunk-2d2290e1"
	],
	"./docs/picker.md": [
		"d953",
		"chunk-2d21f2a9"
	],
	"./docs/preview.md": [
		"04fb",
		"chunk-2d0a42b6"
	],
	"./docs/progress.md": [
		"5f95",
		"chunk-5c9899be"
	],
	"./docs/search-bar.md": [
		"bc5f",
		"chunk-2d21a7c8"
	],
	"./docs/slider.md": [
		"1e96",
		"chunk-2d0b6967"
	],
	"./docs/tabbar.md": [
		"d233",
		"chunk-427bf597"
	],
	"./docs/toast.md": [
		"c2c8",
		"chunk-2d21699a"
	],
	"./docs/toptips.md": [
		"6cbb",
		"chunk-2d0dace3"
	],
	"./docs/uploader.md": [
		"4b34",
		"chunk-7ced5800"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "20d2";
module.exports = webpackAsyncContext;